import React from 'react';
import CreditCards from './creditCards';

const CardWrapper = ({ children, heading, icon }) => {
	return (
		<div className="cardInformation">
			<div className="cardInformation__heading">
				<span>{heading}</span>
				<CreditCards />
			</div>
			<div className="cardInformation__wrapper">{children}</div>
		</div>
	);
};

export default CardWrapper;
